import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { FAQS } from '../mock';
import FadeInSection from './FadeInSection';
import SafeMotion from './SafeMotion';

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" className="relative py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-6">
        <FadeInSection className="text-center">
          <h2 className="font-display font-extrabold text-white text-4xl md:text-5xl leading-[1.05] tracking-tight">
            Frequently asked <span className="text-orange-gradient">questions</span>
          </h2>
          <p className="mt-4 text-[#f2f2f2] text-[15px]">Everything you need to know about the MBE Road To Bali Challenge.</p>
        </FadeInSection>

        <div className="mt-10 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <SafeMotion
                key={f.q}
                initial={{ filter: 'blur(8px)', opacity: 0, y: 20 }}
                whileInView={{ filter: 'blur(0px)', opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.1, margin: '0px 0px -50px 0px' }}
                transition={{ duration: 0.6, ease: 'easeOut', delay: i * 0.08 }}
                className="card-dark p-5"
              >
                <button className="w-full flex items-center justify-between text-left" onClick={() => setOpen(isOpen ? -1 : i)}>
                  <span className="text-white font-medium text-[15px]">{f.q}</span>
                  <span className="icon-badge shrink-0" style={{ width: 32, height: 32 }}>
                    {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                  </span>
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100 mt-3' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <p className="text-[#f2f2f2] text-[14px] leading-relaxed">{f.a}</p>
                  </div>
                </div>
              </SafeMotion>
            );
          })}
        </div>
      </div>
    </section>
  );
}
